
var id = "funnelPlot";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"funnelPlot\">\n<style type=\"text/css\">\n\t#funnelPlot .st0{fill:#616161;}\n</style>\n<path class=\"st0\" d=\"M15.3,1.3C15.7,1.3,16,1.6,16,2c0,0.1,0,0.2-0.1,0.3l-7.3,12c-0.1,0.2-0.3,0.3-0.6,0.3l-0.1,0\n\tc-0.2,0-0.4-0.1-0.5-0.3l-7.3-12C-0.1,2,0,1.6,0.3,1.4c0.1-0.1,0.2-0.1,0.3-0.1H15.3z M9.9,9.6H6.1L8,12.7L9.9,9.6z M11.9,6.3H4.1\n\tl1.2,2h5.4C10.7,8.3,11.9,6.3,11.9,6.3z M14.2,2.7H1.9L3.3,5h9.5L14.2,2.7z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
